export default class Server500Error extends Error{
  constructor(message: string) {
    super();
    this.message = message;
    this.stack = (new Error()).stack;
    this.name = this.constructor.name;
  }
}